import * as d3 from 'd3';
import { makeRequest } from '@/appland/util';

export default function (containerSelection) {
  let scenario;

  function renderModal(response) {
    $(containerSelection.node()).find('.modal-body').html(response);

    containerSelection.select('form').each(function () {
      const form = d3.select(this);

      form.select('button.save').on('click', submitScenarioData);
    });

    containerSelection.select('.input-dark').node().value = window.location;
    containerSelection.select('.input-dark').on('focus', function () {
      this.select();
    });
    containerSelection.select('input[name="link_sharing"]').on('change', submitScenarioData);
  }

  function submitScenarioData() {
    d3.event.preventDefault();

    const data = $(containerSelection.node())
      .find('form')
      .serializeArray()
      .reduce((memo, e) => {
        if (e.value && e.value !== '') {
          memo[e.name] = e.value;
        }
        return memo;
      }, {});

    makeRequest('put', `/scenarios/${scenario().id}`, 'application/json', JSON.stringify(data));

    return false;
  }

  function scenarioShare() {
    $(containerSelection.node()).on('show.bs.modal', () => {
      makeRequest('get', `/scenarios/${scenario().id}/share`).then((modalContent) =>
        renderModal(modalContent)
      );
    });
  }

  scenarioShare.scenario = function (v) {
    return arguments.length ? ((scenario = v), scenarioShare) : scenario;
  };

  return scenarioShare;
}
